<template>
  <div class="log">
    <template v-if="list.length">
      <div class="log__list">
        <v-action-log-list-item
          v-for="item in list"
          :id="item.id"
          :action="item.action"
          :created="item.createdAt"
          :count="item.criteriaCount"
          :key="item.id"
        />
      </div>
    </template>
    <template v-else>
      <p>{{ $t('c.logList.textEmptyListActions') }}</p>
    </template>
  </div>
</template>

<script>
import VActionLogListItem from '@/components/ActionLog/VActionLogListItem.vue'

export default {
  name: 'VActionLogList',

  components: {
    VActionLogListItem
  },

  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>
